import { useCallback } from 'react';
import { useListMachinesLazyQuery } from '../graphql/generated';

type FetchInactive = () => Promise<number | undefined>;

const useInactiveMachinesCount = (teamId: string): FetchInactive => {
  const [fetch] = useListMachinesLazyQuery({
    variables: { input: { teamId, active: false, limit: 0 } },
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'standby',
  });

  const fetchInactive: FetchInactive = useCallback(async (): Promise<
    number | undefined
  > => {
    const response = await fetch();
    return response.data?.listMachines.total ?? undefined;
  }, [fetch]);

  return fetchInactive;
};

export { useInactiveMachinesCount };
